import { checkAndRequestNotificationPermissions } from "@stepapp/core";
import { Block, Button, Image, Typography, spacing } from "@stepapp/ui";
import { useRouter } from "expo-router";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { Alert, Linking, ScrollView, StyleSheet } from "react-native";

import { secondNotificationsReminder, welcomeNotifications } from "../../src/assets/images";
import { useCanGoBack } from "../../src/hooks";
import { AppStorage } from "../../src/services/AppStorage";

const NotificationsCheck = () => {
  const { t } = useTranslation();
  const { navigate, back } = useRouter();
  const canGoBack = useCanGoBack();
  const secondTime = !!AppStorage().get("sawNotifications");

  const handleGoBack = useCallback(() => {
    AppStorage().set("sawNotifications", true);
    if (!canGoBack) {
      navigate("/");
      return;
    }

    back();
  }, [back, canGoBack, navigate]);

  const handleEnableNotifications = useCallback(async () => {
    const granted = await checkAndRequestNotificationPermissions();

    handleGoBack();

    if (!granted) {
      Alert.alert(
        t("notifications.permissionDenied.notifications"),
        t("notifications.permissionDenied.notificationsDescription"),
        [
          { text: t("common.OK"), onPress: handleGoBack, style: "cancel" },
          { text: t("screens.settings.title"), onPress: () => Linking.openSettings() },
        ],
      );
    }
  }, [handleGoBack, t]);

  return (
    <ScrollView>
      <Block alignCenter justifyCenter paddingBottom={2}>
        <Image
          contentFit="contain"
          height={spacing.unit * 20}
          source={secondTime ? secondNotificationsReminder : welcomeNotifications}
          style={styles.image}
          width={spacing.deviceWidth * 0.7}
        />
        <Block paddingTop={6}>
          <Typography center variant="title">
            {secondTime
              ? t("screens.notificationsCheck.secondTitle")
              : t("screens.notificationsCheck.title")}
          </Typography>
        </Block>
        <Block marginBottom={5} marginHorizontal={2.5} marginTop={2.5}>
          <Typography center type="secondary" variant="body">
            {secondTime
              ? t("screens.notificationsCheck.secondDescription")
              : t("screens.notificationsCheck.description")}
          </Typography>
        </Block>
      </Block>

      <Button
        label={t("screens.notificationsCheck.enableNotifications")}
        onPress={handleEnableNotifications}
        style={styles.footerButton}
        type="primary"
      />

      <Button
        label={t("common.skip")}
        onPress={handleGoBack}
        style={styles.footerButton}
        type="tertiary"
      />
    </ScrollView>
  );
};

export default NotificationsCheck;

const styles = StyleSheet.create({
  footerButton: {
    alignSelf: "center",
    width: spacing.deviceWidth * 0.7,
  },
  image: {
    alignSelf: "center",
    marginBottom: spacing.unit * 3,
    marginTop: spacing.deviceHeight * 0.1,
    width: spacing.deviceWidth * 0.7,
  },
});
